// src/modules/menu/menuService.js
import axios from "../../config/axiosConfig";

const API_PREFIX =
  axios?.defaults?.baseURL && axios.defaults.baseURL.includes("/api")
    ? ""
    : "/api";

// --- Admin: exporta TODO el árbol (sin filtro de rol)
async function exportTree() {
  const { data } = await axios.get(`${API_PREFIX}/menu/export`);
  return data;
}

async function createItem(payload) {
  const { data } = await axios.post(`${API_PREFIX}/menu`, payload);
  return data;
}

async function updateItem(id, payload) {
  const { data } = await axios.put(`${API_PREFIX}/menu/${id}`, payload);
  return data;
}

async function deleteItem(id) {
  const { data } = await axios.delete(`${API_PREFIX}/menu/${id}`);
  return data;
}

async function reorderItem(id, direction) {
  const { data } = await axios.patch(`${API_PREFIX}/menu/reorder`, {
    id,
    direction,
  });
  return data;
}

// --- KEYS (cache simple en memoria)
let _embedKeysCache = null;
async function getEmbedKeys({ force = false } = {}) {
  if (!force && _embedKeysCache) return _embedKeysCache;
  const { data } = await axios.get(`${API_PREFIX}/menu/embed-keys`);
  _embedKeysCache = data?.keys || {};
  return _embedKeysCache;
}

// 👇 esta parte es la que cambia
const menuService = {
  exportTree,
  createItem,
  updateItem,
  deleteItem,
  reorderItem,
  getEmbedKeys,
};

export default menuService;
